/**
 * CapacityRuleMeters — the live readout for one capacity rule.
 * For Media Devoted | Created By Ciro Autiero
 *
 * Always visible, even while the rule's controls are collapsed: the numbers are
 * what you open this section to see, the inputs are what you open a rule to
 * change. "Rule paths" caps EACH group, so it gets one meter per group.
 */

import { FC } from 'react';
import type { CapacityRule, CapacitySlot } from '@trafficpulse/shared';

import { SLOT_LABEL, type SlotActiveCounts } from '../capacity-rules';
import CapacityMeter from './CapacityMeter';

export interface RuleGroupMeter {
  id: string;
  name: string;
  active: number;
}

export interface CapacityRuleMetersProps {
  rule: CapacityRule;
  slot: CapacitySlot;
  counts: SlotActiveCounts;
  ruleGroups: RuleGroupMeter[];
}

export const CapacityRuleMeters: FC<CapacityRuleMetersProps> = ({
  rule,
  slot,
  counts,
  ruleGroups,
}) => {
  if (slot !== 'paths-rules') {
    return (
      <CapacityMeter
        label={SLOT_LABEL[slot]}
        active={counts.bySlot[slot] ?? 0}
        max={rule.max}
        min={rule.min}
      />
    );
  }
  if (ruleGroups.length === 0) {
    return (
      <span className="text-[11px] italic text-muted-foreground">
        No rule groups on the flow yet — the limits apply to each as it appears.
      </span>
    );
  }
  return (
    <>
      {ruleGroups.map((g) => (
        <CapacityMeter
          key={g.id}
          label={g.name}
          active={g.active}
          max={rule.max}
          min={rule.min}
        />
      ))}
    </>
  );
};

export default CapacityRuleMeters;
